module.exports = __webpack_public_path__ + "img/Ball-age-zvuk.0ede071a.jpg";